// extracted by mini-css-extract-plugin
export var label = "color-mode-switch-module--label--VC-zs";
export var icon = "color-mode-switch-module--icon---2E3f";